import flagKeys from '@/constants/flagKeys';
import Overview from '@/views/Performance/Overview.vue';

import { Route } from '../../route.model';

const overview = new Route(
  '/performance/overview',
  'performance-overview',
  Overview,
  {
    requiresAuth: true,
    isResponsive: true,
    flag: flagKeys.merchantDashboardReports,
    zendesk: {
      mobile: {
        offsetHorizontal: '4px',
        offsetVertical: '4px'
      }
    },
    navbar: {
      name: 'Overview',
      icon: 'overview',
      description:
        'A quick snapshot of customers and activity of Coins in circulation.'
    },
    pageView: {
      eventLabel: 'Performance Overview'
    }
  }
);

export { overview };
export default overview;
